import React, { useContext, useEffect, useRef, useState } from 'react';
import { useCreateResponseTask } from '../../../../../../services/task/mutations';
import {
  Task,
  TaskResponse,
  TaskState
} from '../../../../../../gql/graphql';
import { TaskContext } from '../Payoff';
import ModalFinishTask from './ModalFinishTask';
import { useGetTaskResponsesByTask } from '../../../../../../services/task/querys';
import CardLender from './CardLender';
import CardUploadResponse from 'components/Atoms/Cards/CardUploadResponse/CardUploadResponse';
import SectionErrorTask from 'scenes/Private/components/SectionErrorTask/SectionErrorTask';
import SectionSuccessTask from 'scenes/Private/components/SectionSuccessTask/SectionSuccessTask';
import CollapseIssues from 'scenes/Private/components/CollapseIssues/CollapseIssues';
import AddAnotherDoc from 'scenes/Private/components/AddAnotherDoc/AddAnotherDoc';

interface Props {
  setStep: Function;
  closeTask: Function;
}

const Step2 = ({ setStep, closeTask }: Props) => {
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });
  const { fetching, execute: createResponseTask } = useCreateResponseTask();

  const [modalFinishTask, setModalFinishTask] = useState<boolean>(false);
  const [responseStep1, setResponseStep1] = useState<TaskResponse | any>();
  const [responsePayoffLetter, setResponsePayoffLetter] = useState<TaskResponse | any>();
  const [taskCompleted, setTaskCompleted] = useState<boolean>();
  const [isDataReady, setIsDataReady] = useState<boolean>(false);

  //Implementación para que no se cargue el componente hasta que se haya obtenido la respuesta del step 1
  const hasFetchedFresh = useRef<boolean>(false);

  useEffect(() => {
    hasFetchedFresh.current = false;
    setIsDataReady(false);
    getTaskResponses({ requestPolicy: 'network-only' });
  }, []);

  useEffect(() => {
    if (!hasFetchedFresh.current) {
      hasFetchedFresh.current = true;
      return;
    }

    const _response1 = taskResponses?.find((item) => item.step === 1);
    setResponseStep1(_response1);

    const _response = taskResponses?.find((item) => item.key === 'payoff-letter');
    setResponsePayoffLetter(_response);

    const _responseLender = taskResponses?.find((item) => item.key === 'payoff-lender');

    setTaskCompleted(_response?.state === TaskState.Approved || _responseLender?.state === TaskState.Approved);
    setIsDataReady(true);
  }, [taskResponses]);

  const submit = async (files: any) => {
    let payload: any = {
      key: 'payoff-letter',
      label: 'Payoff letter',
      step: 2,
      metadata: {},
      state: TaskState.Review,
      task: task?._id,
      files
    };

    if (responsePayoffLetter) payload._id = responsePayoffLetter._id;

    await createResponseTask(payload);
    getTaskResponses({ requestPolicy: 'network-only' });
    setModalFinishTask(true);
  };

  if (!isDataReady || !responseStep1) return null;

  return (
    <section className='insurance-step-2 '>
      <div className="section-1">
        <h3 className="h3">
          {responseStep1?.key === 'yes' ? 'Upload your payoff letter' : 'Who is your current lender?'}
        </h3>
        <div className="mt-10">
          <p className="h4 h4-w4">
            {responseStep1?.key === 'yes' ?
              'Remember, it needs to be good through the closing date' :
              'We’ll reach out and get a up-to-date payoff letter'
            }
          </p>
        </div>

        {taskCompleted &&
          <SectionSuccessTask
            title="You've completed this task."
            button={{ title: "Back to dashboard", onClick: closeTask }}
          />
        }

        {!taskCompleted &&
          <SectionErrorTask
            taskId={task._id}
            componentDataError={(textDataError: any) => (
              <div className='text-data'>
                <div className='row'>
                  <span>Lender name</span>
                  <b>{textDataError.lenderName}</b>
                </div>
                <div className='row'>
                  <span>Contact name</span>
                  <b>{textDataError.name}</b>
                </div>
                <div className='row'>
                  <span>Phone number</span>
                  <b>{textDataError.phone}</b>
                </div>
                <div className='row'>
                  <span>Email address</span>
                  <b>{textDataError.email}</b>
                </div>
              </div>
            )}
          />
        }

        <div id={responsePayoffLetter?._id} className="mt-40">
          {responseStep1?.key === 'yes' &&
            <CardUploadResponse
              title="Payoff letter"
              isButtonSample={{ show: true, link: '' }}
              files={responsePayoffLetter?.files}
              state={responsePayoffLetter?.state}
              limitFiles={1}
              submit={{
                title: 'Submit for review',
                disabled: responsePayoffLetter?.state === TaskState.Approved || responsePayoffLetter?.state === TaskState.Review,
                loading: fetching,
                modalConfirm: true,
                confirmDescription:
                  "After submitting, you'll have to contact us to make any changes.",
                onClick: (files) => submit(files)
              }}
            />
          }

          {responseStep1?.key === 'no' &&
            <CardLender setModalFinishTask={setModalFinishTask} />
          }

        </div>
      </div>

      <AddAnotherDoc taskId={task._id} taskState={task.state} />

      <CollapseIssues taskId={task._id} taskKey={task.key} rejectionCode='no_action_required' />

      <ModalFinishTask
        visible={modalFinishTask}
        setVisible={setModalFinishTask}
        closeTask={closeTask}
      />
    </section>
  );
};
export default Step2;
